// 本机皮肤标识与名称；颜色和材质只由 design-tokens.scss 维护。
export const TERMINAL_SKINS = Object.freeze([
  { id: 'charcoal', name: '炭灰青绿', description: '深炭工作台 · 青绿细节点缀' },
  { id: 'dark', name: '简洁黑色', description: '经典深色工作台' },
  { id: 'ocean', name: '深海科技蓝', description: '哑光海军蓝 · 精细冷光边缘' },
  { id: 'silver', name: '精制银灰', description: '石墨框架 · 冷银哑光面板' },
  { id: 'pearl', name: '珍珠浅色', description: '柔白材质 · 细腻高光与柔影' }
])

export function normalizeTerminalSkin (skin) {
  return TERMINAL_SKINS.some(item => item.id === skin) ? skin : 'charcoal'
}

export function applyTerminalSkin (skin) {
  document.documentElement.dataset.uiSkin = normalizeTerminalSkin(skin)
}
